import { render, staticRenderFns } from "./FileDetails.vue?vue&type=template&id=c023e8e2&"
import script from "./FileDetails.vue?vue&type=script&lang=js&"
export * from "./FileDetails.vue?vue&type=script&lang=js&"
import style0 from "./FileDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports